import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useState } from "react";

export default function PaymentForm({ onNext, customerId }) {  
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

 const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setErrorMessage("");

    try {
      const result = await stripe.confirmPayment({
        elements,
        redirect: "if_required",
      });

      console.log("Result from confirmPayment:", result);

      if (result.error) {
        setErrorMessage(result.error.message || "Errore nel pagamento.");
        setLoading(false);
        return;
      }

      // Log dati utili
      console.log("PaymentIntent ID:", result.paymentIntent?.id);
      console.log("PaymentIntent status:", result.paymentIntent?.status);
      console.log("Customer ID:", customerId);

      const token = localStorage.getItem("jwt_token");
      const host = import.meta.env.VITE_HOST;
      const port = import.meta.env.VITE_PORT;

      if (result.paymentIntent?.status === "succeeded") {
        // Chiamata al backend per confermare ordine
        const response = await fetch(`${host}:${port}/api/v1/orders/confirm_payment`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            payment_intent_id: result.paymentIntent.id,
            customer_id: customerId,
          }),
        });

        let data = null;
        const text = await response.text();

        try {
          data = text ? JSON.parse(text) : null;
        } catch (e) {
          console.warn("Risposta backend non è JSON valido:", text);
        }

        if (!response.ok) {
          setErrorMessage(data?.detail || "Errore nella conferma ordine backend");
          setLoading(false);
          return;
        }

        console.log("Conferma ordine backend:", data);

        // Passa allo step successivo o mostra messaggio
        if (onNext) onNext();

      } else {
        console.log("Pagamento non completato con successo, status:", result.paymentIntent?.status);
        setErrorMessage("Pagamento non completato con successo.");
      }
    } catch (error) {
      console.error("Errore nella conferma pagamento:", error);
      setErrorMessage("Errore nella conferma del pagamento.");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <h2 className="text-2xl font-bold text-center text-gray-800">Completa il pagamento</h2>

      <div className="p-4 bg-gray-50 border rounded-lg shadow-sm">
        <PaymentElement
          options={{
            layout: "tabs",
          }}
        />
      </div>

      {errorMessage && (
        <div className="text-red-600 text-sm mt-2 text-center">{errorMessage}</div>
      )}

      <button
        type="submit"
        disabled={loading || !stripe || !elements}
        className="bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-900 w-full transition duration-300"
      >
        {loading ? "Elaborazione in corso..." : "Paga ora"}
      </button>
    </form>
  );
}
